var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSelectDate = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 9.16683V15.3335C3.33325 16.0699 3.93021 16.6668 4.66659 16.6668H15.3333C16.0696 16.6668 16.6666 16.0699 16.6666 15.3335V9.16683M3.33325 9.16683V6.00016C3.33325 5.26378 3.93021 4.66683 4.66659 4.66683H15.3333C16.0696 4.66683 16.6666 5.26378 16.6666 6.00016V9.16683M3.33325 9.16683H16.6666M7.33325 3.3335V6.00016M12.6666 3.3335V6.00016M13.9999 12.6668H7.99992",
    stroke: "#363A44",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSelectDate);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/select_date_.92f628e60ff740511e3aa45c27658240.svg";